import { render, staticRenderFns } from "./table.admin.research.vue?vue&type=template&id=44d0d08a&"
import script from "./table.admin.research.vue?vue&type=script&lang=ts&"
export * from "./table.admin.research.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports